import type { FaireProductEntity } from "../../entity_types/product";

export const p_vpjuh42wx6: FaireProductEntity = {
  token: "p_vpjuh42wx6",
  type: "product",
  name: "Pumpkin Habanero Artisan Hot Sauce",
  brandToken: "b_8rugen3wze",
  brandName: "Haxan Ferments",
  imageUrl:
    "https://cdn.faire.com/fastly/7f7f1505abe5dfb59e6c70dcc798507e7ab23081901023f72ffbdc1d7d70a479.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9f30ce3696c5c302ba3c7c8b9988c1691d56f97064667870f44dcd30f928995e.png",
    "https://cdn.faire.com/fastly/2691ce728f7aadfd311ed13809ad07704151432515c52c90c619604417fb2176.png",
    "https://cdn.faire.com/fastly/34b5a9fdf1b623630db0ae63047e8c78f3187a5bbc85ad6efef07c2013cd12fe.png",
    "https://cdn.faire.com/fastly/00d5647ce89eb4fb8f1f214bb655f8ff3a09cf6a77537174f98182e8259de7eb.png",
    "https://cdn.faire.com/fastly/ec00c002bb89850bcf2ef03d9b2c33fd1ee95544cdf2471354e47eb198539746.jpeg",
  ],
  priceDollars: 5,
  description:
    "The question every new customer asks: why pumpkin in a hot sauce? One taste answers it.\nFermented pumpkin and habanero peppers are blended with ginger, garlic, and onion into a sauce that's tangy, bright, and earthy-sweet- no added sugar, just the natural sweetness fermentation draws out of the pumpkin. The ginger and garlic keep it savory rather than letting the heat run the show. It's spicy but full of flavor. \n\nA great seasonal anchor for fall merchandising, but genuinely good enough to sell year-round. Excellent on stir-fried vegetables, seafood, and chili!\n\nHot\nVegetarian and gluten-free\nMade by hand in small batches in Seattle, WA\nCrafted with real pumpkin, no added sugar\n4 oz bottle / Case of 6\nShelf stable 1 year unopened; refrigerate after opening\n\nIngredients: pumpkin, habanero peppers, onion, white wine vinegar, ginger, garlic, water, salt",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:53:41.096Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
